import { render } from "./item-message.vue?vue&type=template&id=5c592535&scoped=true"
import script from "./item-message.vue?vue&type=script&lang=js"
export * from "./item-message.vue?vue&type=script&lang=js"

import "./item-message.vue?vue&type=style&index=0&id=5c592535&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c592535"]])

export default __exports__